// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shifts-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.shifts-day-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.shifts-row-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.25rem;
}

.shifts-hours-summary {
  font-size: 0.875rem;
  color: var(--m-text);
  font-weight: 500;
}

.shifts-hours-summary--muted {
  color: var(--m-text-subtle, #6b7280);
  font-weight: 400;
  font-size: 0.8125rem;
}

.shifts-hours-cell {
  position: relative;
  display: inline-block;
  max-width: 220px;
}

.shifts-cell-action-btn {
  padding: 0 !important;
  min-height: unset !important;
  background: transparent !important;
  border: none !important;
}
.shifts-cell-action-btn:hover {
  background: transparent !important;
}
.shifts-cell-action-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 82, 204, 0.25);
  border-radius: 8px;
}

.shifts-cell-chip {
  padding: 0 !important;
  min-height: unset !important;
  border: none !important;
  background: transparent !important;
}
.shifts-cell-chip:hover {
  background: transparent !important;
}
.shifts-cell-chip__inner {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.2rem 0.45rem;
  border-radius: 999px;
  border: 1px solid var(--m-border, #e5e7eb);
  background: var(--m-subtle, #f8f9fb);
  color: var(--m-text);
  font-weight: 700;
  font-size: 0.75rem;
  line-height: 1;
  white-space: nowrap;
}
.shifts-cell-chip__count {
  min-width: 1.2rem;
  text-align: center;
}
.shifts-cell-chip:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 82, 204, 0.25);
  border-radius: 999px;
}

.shifts-details-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.shifts-details-header {
  padding: 0.6rem 0.7rem;
  border: 1px solid var(--m-border, #e5e7eb);
  border-radius: 10px;
  background: linear-gradient(180deg, rgba(0, 82, 204, 0.06), rgba(0, 82, 204, 0.02));
}

.shifts-details-header__title {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--m-text);
  line-height: 1.15;
}

.shifts-details-header__sub {
  margin-top: 0.15rem;
  font-size: 0.75rem;
  color: var(--m-text-subtle, #6b7280);
}

.shifts-details-card {
  flex: 1 1 13.5rem;
  min-width: 13.5rem;
  border: 1px solid var(--m-border, #e5e7eb);
  border-radius: 8px;
  background: var(--m-background-card, #fff);
  padding: 0.5rem 0.6rem;
}

.shifts-details-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
}

.shifts-details-card__title {
  font-weight: 600;
  color: var(--m-text);
  font-size: 0.8125rem;
  line-height: 1.2;
}

.shifts-details-card__sub {
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: var(--m-text-subtle, #6b7280);
}

.shifts-details-card__meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.15rem;
}

.shifts-details-card__head .d-flex {
  flex-wrap: nowrap;
}

.shifts-details-card__time {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--m-text);
  white-space: nowrap;
}

.shifts-details-breaks {
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.shifts-details-break {
  padding: 0.35rem 0.45rem;
  border: 1px solid var(--m-border, #e5e7eb);
  border-radius: 6px;
  background: var(--m-subtle, #f8f9fb);
}

.shifts-details-break__row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
}

.shifts-details-break__name {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--m-text);
  line-height: 1.2;
}

.shifts-details-break__time {
  font-size: 0.6875rem;
  color: var(--m-text-subtle, #6b7280);
  white-space: nowrap;
}

.shifts-details-toggle {
  padding: 0 !important;
  min-height: unset !important;
  border: none !important;
  background: transparent !important;
  display: inline-flex !important;
  align-items: center;
  gap: 0.35rem;
}
.shifts-details-toggle:hover {
  background: transparent !important;
}
.shifts-details-toggle:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 82, 204, 0.25);
  border-radius: 8px;
}

.shifts-details-breaks-toggle {
  border: none;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  cursor: pointer;
}

.shifts-details-breaks-toggle:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 82, 204, 0.25);
  border-radius: 8px;
}

.shift-form-page {
  padding: 1.5rem 1.75rem 2rem;
}
@media (max-width: 767px) {
  .shift-form-page {
    padding: 1rem 1rem 1.25rem;
  }
}
.shift-form-page .shift-form-page__section {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.shift-form-page .shift-form-page__section-title {
  margin: 0 0 0.25rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--m-text);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.shift-form-page .shift-form-page__section-title svg {
  color: var(--m-primary);
  flex-shrink: 0;
}
.shift-form-page .shift-form-page__section-title--compact {
  font-size: 0.9375rem;
  margin-bottom: 0.15rem;
}
.shift-form-page .shift-form-page__section-sub {
  margin: -0.25rem 0 0.5rem;
  font-size: 0.8125rem;
  color: var(--m-text-subtle, #6b7280);
  line-height: 1.4;
}
.shift-form-page .shift-form-page__weekly {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 17.5rem), 1fr));
  gap: 0.5rem;
  align-items: start;
}
.shift-form-page .shift-form-page__day-block {
  border: 1px solid var(--m-border, #e5e7eb);
  border-radius: 6px;
  background: var(--m-background-card, #fff);
  padding: 0.4rem 0.55rem 0.45rem;
  transition: opacity 0.15s ease, border-color 0.15s ease;
}
.shift-form-page .shift-form-page__day-block--muted {
  opacity: 0.78;
  background: var(--m-subtle, #f8f9fb);
}
.shift-form-page .shift-form-page__day-block--toggle {
  cursor: pointer;
  outline: none;
}
.shift-form-page .shift-form-page__day-block--toggle:focus-visible {
  box-shadow: 0 0 0 2px var(--m-background-card, #fff), 0 0 0 4px var(--m-primary);
}
.shift-form-page .shift-form-page__day-block--toggle [data-shift-day-interactive] {
  cursor: auto;
}
.shift-form-page .shift-form-page__day-block-head {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-rows: auto auto;
  gap: 0.35rem 0.4rem;
  align-items: end;
}
.shift-form-page .shift-form-page__day-block-toggle {
  grid-column: 1;
  grid-row: 1;
  min-width: 0;
}
.shift-form-page .shift-form-page__day-block-toggle .d-flex label {
  white-space: normal;
  line-height: 1.25;
  font-size: 0.8125rem;
  flex: 1 1;
  min-width: 0;
}
.shift-form-page .shift-form-page__day-block-corner {
  grid-column: 2;
  grid-row: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 0.15rem;
  flex-shrink: 0;
  padding-top: 0.05rem;
}
.shift-form-page .shift-form-page__day-block-times {
  grid-column: 1/-1;
  grid-row: 2;
  display: flex;
  gap: 0.35rem;
  min-width: 0;
  align-items: flex-end;
}
.shift-form-page .shift-form-page__day-block-times > div {
  flex: 1 1;
  min-width: 0;
  max-width: none;
}
.shift-form-page .shift-form-page__time-field-label {
  font-size: 0.65rem;
  line-height: 1.2;
  color: var(--m-text-subtle, #6b7280);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.shift-form-page .shift-form-page__day-breaks-badge {
  margin-top: 0.35rem;
  padding-top: 0.35rem;
  border-top: 1px solid var(--m-border, #e5e7eb);
}
.shift-form-page .shift-form-page__day-breaks-badge-btn {
  display: block;
  width: 100%;
  padding: 0.25rem 0.35rem;
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--m-primary);
  background: var(--m-background-subtle-primary, rgba(0, 82, 204, 0.08));
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  transition: background 0.15s ease;
}
.shift-form-page .shift-form-page__day-breaks-badge-btn:hover {
  background: var(--m-subtle, #f1f2f4);
}
.shift-form-page .shift-form-page__breaks-modal-list li:last-child {
  border-bottom: none !important;
}
.shift-form-page .shift-form-page__breaks-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.shift-form-page .shift-form-page__break-card {
  padding: 0.55rem 0.65rem;
  border-radius: 5px;
  border: 1px solid var(--m-border, #e5e7eb);
  background: var(--m-subtle, #f8f9fb);
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.shift-form-page .shift-form-page__break-card--nested {
  background: var(--m-background-card, #fff);
}
.shift-form-page .shift-form-page__break-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.shift-form-page .shift-form-page__break-index {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--m-text);
}
.shift-form-page .shift-form-page__empty-breaks {
  text-align: center;
  padding: 1.75rem 1rem;
  font-size: 0.8125rem;
  color: var(--m-text-subtle, #6b7280);
  border: 1px dashed var(--m-border, #e5e7eb);
  border-radius: var(--m-border-radius, 6px);
  line-height: 1.5;
}
.shift-form-page .shift-form-page__time-row {
  display: flex;
  gap: 0.35rem;
}
.shift-form-page .shift-form-page__time-row > div {
  flex: 1 1;
  min-width: 0;
  max-width: 6.5rem;
}
.shift-form-page .shift-form-page__active-row {
  padding-top: 0.25rem;
  border-top: 1px solid var(--m-border, #e5e7eb);
  margin-top: auto;
}

.shift-form-loading .spin {
  animation: shifts-spin 1s linear infinite;
}

@keyframes shifts-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.shift-form-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1.5rem;
  color: var(--m-text-subtle, #6b7280);
}
.shift-form-loading svg {
  color: var(--m-primary);
  margin-bottom: 1rem;
}
.shift-form-loading p {
  margin: 0;
  font-size: 0.9375rem;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/Shifts/Shifts.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,eAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;AAAF;;AAGA;EACE,mBAAA;EACA,oBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,oCAAA;EACA,gBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,qBAAA;EACA,4BAAA;EACA,kCAAA;EACA,uBAAA;AAAF;AAEE;EACE,kCAAA;AAAJ;AAGE;EACE,aAAA;EACA,4CAAA;EACA,kBAAA;AADJ;;AAKA;EACE,qBAAA;EACA,4BAAA;EACA,uBAAA;EACA,kCAAA;AAFF;AAIE;EACE,kCAAA;AAFJ;AAKE;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,0CAAA;EACA,oCAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAHJ;AAME;EACE,iBAAA;EACA,kBAAA;AAJJ;AAOE;EACE,aAAA;EACA,4CAAA;EACA,oBAAA;AALJ;;AASA;EACE,aAAA;EACA,eAAA;EACA,YAAA;AANF;;AASA;EACE,sBAAA;EACA,0CAAA;EACA,mBAAA;EACA,mFAAA;AANF;;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AAVF;;AAaA;EACE,mBAAA;EACA,kBAAA;EACA,oCAAA;AAVF;;AAaA;EACE,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,0CAAA;EACA,sBAAA;AAVF;;AAaA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,WAAA;AAVF;;AAaA;EACE,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,gBAAA;AAVF;;AAaA;EACE,mBAAA;EACA,kBAAA;EACA,oCAAA;AAVF;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;AAVF;;AAaA;EACE,iBAAA;AAVF;;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAVF;;AAaA;EACE,wBAAA;EACA,0CAAA;EACA,kBAAA;EACA,oCAAA;AAVF;;AAaA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,WAAA;AAVF;;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AAVF;;AAaA;EACE,oBAAA;EACA,oCAAA;EACA,mBAAA;AAVF;;AAaA;EACE,qBAAA;EACA,4BAAA;EACA,uBAAA;EACA,kCAAA;EACA,+BAAA;EACA,mBAAA;EACA,YAAA;AAVF;AAYE;EACE,kCAAA;AAVJ;AAaE;EACE,aAAA;EACA,4CAAA;EACA,kBAAA;AAXJ;;AAeA;EACE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAZF;;AAeA;EACE,aAAA;EACA,4CAAA;EACA,kBAAA;AAZF;;AAgBA;EACE,4BAAA;AAbF;AAeE;EAHF;IAII,0BAAA;EAZF;AACF;AAcE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAZJ;AAeE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAbJ;AAeI;EACE,uBAAA;EACA,cAAA;AAbN;AAgBI;EACE,oBAAA;EACA,sBAAA;AAdN;AAkBE;EACE,yBAAA;EACA,oBAAA;EACA,oCAAA;EACA,gBAAA;AAhBJ;AAmBE;EACE,aAAA;EACA,yEAAA;EACA,WAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,0CAAA;EACA,kBAAA;EACA,0CAAA;EACA,+BAAA;EACA,uDACE;AAnBN;AAsBI;EACE,aAAA;EACA,oCAAA;AApBN;AAuBI;EACE,eAAA;EACA,aAAA;AArBN;AAuBM;EACE,gFACE;AAtBV;AA0BM;EACE,YAAA;AAxBR;AA6BE;EACE,aAAA;EACA,0CAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;AA3BJ;AA8BE;EACE,cAAA;EACA,WAAA;EACA,YAAA;AA5BJ;AA8BI;EACE,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,SAAA;EACA,YAAA;AA5BN;AAgCE;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;AA9BJ;AAiCE;EACE,iBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;AA/BJ;AAiCI;EACE,SAAA;EACA,YAAA;EACA,eAAA;AA/BN;AAmCE;EACE,kBAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;EACA,sBAAA;AAjCJ;AAoCE;EACE,mBAAA;EACA,oBAAA;EACA,8CAAA;AAlCJ;AAqCE;EACE,cAAA;EACA,WAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sEAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iCAAA;AAnCJ;AAqCI;EACE,oCAAA;AAnCN;AAuCE;EACE,8BAAA;AArCJ;AAwCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AAtCJ;AAyCE;EACE,wBAAA;EACA,kBAAA;EACA,0CAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAvCJ;AAyCI;EACE,0CAAA;AAvCN;AA2CE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAzCJ;AA4CE;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;AA1CJ;AA6CE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,oCAAA;EACA,2CAAA;EACA,0CAAA;EACA,gBAAA;AA3CJ;AA8CE;EACE,aAAA;EACA,YAAA;AA5CJ;AA8CI;EACE,SAAA;EACA,YAAA;EACA,iBAAA;AA5CN;AAgDE;EACE,oBAAA;EACA,8CAAA;EACA,gBAAA;AA9CJ;;AAkDA;EACE,yCAAA;AA/CF;;AAkDA;EACE;IACE,uBAAA;EA/CF;EAiDA;IACE,yBAAA;EA/CF;AACF;AAkDA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,oCAAA;AAhDF;AAkDE;EACE,uBAAA;EACA,mBAAA;AAhDJ;AAmDE;EACE,SAAA;EACA,oBAAA;AAjDJ","sourcesContent":["// List page (index)\n.shifts-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.shifts-day-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.shifts-row-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.25rem;\n}\n\n.shifts-hours-summary {\n  font-size: 0.875rem;\n  color: var(--m-text);\n  font-weight: 500;\n}\n\n.shifts-hours-summary--muted {\n  color: var(--m-text-subtle, #6b7280);\n  font-weight: 400;\n  font-size: 0.8125rem;\n}\n\n.shifts-hours-cell {\n  position: relative;\n  display: inline-block;\n  max-width: 220px;\n}\n\n.shifts-cell-action-btn {\n  padding: 0 !important;\n  min-height: unset !important;\n  background: transparent !important;\n  border: none !important;\n\n  &:hover {\n    background: transparent !important;\n  }\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(0, 82, 204, 0.25);\n    border-radius: 8px;\n  }\n}\n\n.shifts-cell-chip {\n  padding: 0 !important;\n  min-height: unset !important;\n  border: none !important;\n  background: transparent !important;\n\n  &:hover {\n    background: transparent !important;\n  }\n\n  &__inner {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.35rem;\n    padding: 0.2rem 0.45rem;\n    border-radius: 999px;\n    border: 1px solid var(--m-border, #e5e7eb);\n    background: var(--m-subtle, #f8f9fb);\n    color: var(--m-text);\n    font-weight: 700;\n    font-size: 0.75rem;\n    line-height: 1;\n    white-space: nowrap;\n  }\n\n  &__count {\n    min-width: 1.2rem;\n    text-align: center;\n  }\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(0, 82, 204, 0.25);\n    border-radius: 999px;\n  }\n}\n\n.shifts-details-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.shifts-details-header {\n  padding: 0.6rem 0.7rem;\n  border: 1px solid var(--m-border, #e5e7eb);\n  border-radius: 10px;\n  background: linear-gradient(\n    180deg,\n    rgba(0, 82, 204, 0.06),\n    rgba(0, 82, 204, 0.02)\n  );\n}\n\n.shifts-details-header__title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--m-text);\n  line-height: 1.15;\n}\n\n.shifts-details-header__sub {\n  margin-top: 0.15rem;\n  font-size: 0.75rem;\n  color: var(--m-text-subtle, #6b7280);\n}\n\n.shifts-details-card {\n  flex: 1 1 13.5rem;\n  min-width: 13.5rem;\n  border: 1px solid var(--m-border, #e5e7eb);\n  border-radius: 8px;\n  background: var(--m-background-card, #fff);\n  padding: 0.5rem 0.6rem;\n}\n\n.shifts-details-card__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.shifts-details-card__title {\n  font-weight: 600;\n  color: var(--m-text);\n  font-size: 0.8125rem;\n  line-height: 1.2;\n}\n\n.shifts-details-card__sub {\n  margin-top: 0.25rem;\n  font-size: 0.75rem;\n  color: var(--m-text-subtle, #6b7280);\n}\n\n.shifts-details-card__meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.15rem;\n}\n\n.shifts-details-card__head .d-flex {\n  flex-wrap: nowrap;\n}\n\n.shifts-details-card__time {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--m-text);\n  white-space: nowrap;\n}\n\n.shifts-details-breaks {\n  margin-top: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.shifts-details-break {\n  padding: 0.35rem 0.45rem;\n  border: 1px solid var(--m-border, #e5e7eb);\n  border-radius: 6px;\n  background: var(--m-subtle, #f8f9fb);\n}\n\n.shifts-details-break__row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.shifts-details-break__name {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--m-text);\n  line-height: 1.2;\n}\n\n.shifts-details-break__time {\n  font-size: 0.6875rem;\n  color: var(--m-text-subtle, #6b7280);\n  white-space: nowrap;\n}\n\n.shifts-details-toggle {\n  padding: 0 !important;\n  min-height: unset !important;\n  border: none !important;\n  background: transparent !important;\n  display: inline-flex !important;\n  align-items: center;\n  gap: 0.35rem;\n\n  &:hover {\n    background: transparent !important;\n  }\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(0, 82, 204, 0.25);\n    border-radius: 8px;\n  }\n}\n\n.shifts-details-breaks-toggle {\n  border: none;\n  background: transparent;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  cursor: pointer;\n}\n\n.shifts-details-breaks-toggle:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(0, 82, 204, 0.25);\n  border-radius: 8px;\n}\n\n// Form page (ShiftForm)\n.shift-form-page {\n  padding: 1.5rem 1.75rem 2rem;\n\n  @media (max-width: 767px) {\n    padding: 1rem 1rem 1.25rem;\n  }\n\n  .shift-form-page__section {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .shift-form-page__section-title {\n    margin: 0 0 0.25rem;\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--m-text);\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n\n    svg {\n      color: var(--m-primary);\n      flex-shrink: 0;\n    }\n\n    &--compact {\n      font-size: 0.9375rem;\n      margin-bottom: 0.15rem;\n    }\n  }\n\n  .shift-form-page__section-sub {\n    margin: -0.25rem 0 0.5rem;\n    font-size: 0.8125rem;\n    color: var(--m-text-subtle, #6b7280);\n    line-height: 1.4;\n  }\n\n  .shift-form-page__weekly {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(min(100%, 17.5rem), 1fr));\n    gap: 0.5rem;\n    align-items: start;\n  }\n\n  .shift-form-page__day-block {\n    border: 1px solid var(--m-border, #e5e7eb);\n    border-radius: 6px;\n    background: var(--m-background-card, #fff);\n    padding: 0.4rem 0.55rem 0.45rem;\n    transition:\n      opacity 0.15s ease,\n      border-color 0.15s ease;\n\n    &--muted {\n      opacity: 0.78;\n      background: var(--m-subtle, #f8f9fb);\n    }\n\n    &--toggle {\n      cursor: pointer;\n      outline: none;\n\n      &:focus-visible {\n        box-shadow:\n          0 0 0 2px var(--m-background-card, #fff),\n          0 0 0 4px var(--m-primary);\n      }\n\n      [data-shift-day-interactive] {\n        cursor: auto;\n      }\n    }\n  }\n\n  .shift-form-page__day-block-head {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    grid-template-rows: auto auto;\n    gap: 0.35rem 0.4rem;\n    align-items: end;\n  }\n\n  .shift-form-page__day-block-toggle {\n    grid-column: 1;\n    grid-row: 1;\n    min-width: 0;\n\n    .d-flex label {\n      white-space: normal;\n      line-height: 1.25;\n      font-size: 0.8125rem;\n      flex: 1;\n      min-width: 0;\n    }\n  }\n\n  .shift-form-page__day-block-corner {\n    grid-column: 2;\n    grid-row: 1;\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-end;\n    gap: 0.15rem;\n    flex-shrink: 0;\n    padding-top: 0.05rem;\n  }\n\n  .shift-form-page__day-block-times {\n    grid-column: 1 / -1;\n    grid-row: 2;\n    display: flex;\n    gap: 0.35rem;\n    min-width: 0;\n    align-items: flex-end;\n\n    > div {\n      flex: 1 1 0;\n      min-width: 0;\n      max-width: none;\n    }\n  }\n\n  .shift-form-page__time-field-label {\n    font-size: 0.65rem;\n    line-height: 1.2;\n    color: var(--m-text-subtle, #6b7280);\n    text-transform: uppercase;\n    letter-spacing: 0.02em;\n  }\n\n  .shift-form-page__day-breaks-badge {\n    margin-top: 0.35rem;\n    padding-top: 0.35rem;\n    border-top: 1px solid var(--m-border, #e5e7eb);\n  }\n\n  .shift-form-page__day-breaks-badge-btn {\n    display: block;\n    width: 100%;\n    padding: 0.25rem 0.35rem;\n    font-size: 0.7rem;\n    font-weight: 600;\n    color: var(--m-primary);\n    background: var(--m-background-subtle-primary, rgba(0, 82, 204, 0.08));\n    border: 1px solid transparent;\n    border-radius: 4px;\n    cursor: pointer;\n    text-align: center;\n    transition: background 0.15s ease;\n\n    &:hover {\n      background: var(--m-subtle, #f1f2f4);\n    }\n  }\n\n  .shift-form-page__breaks-modal-list li:last-child {\n    border-bottom: none !important;\n  }\n\n  .shift-form-page__breaks-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    flex-wrap: wrap;\n  }\n\n  .shift-form-page__break-card {\n    padding: 0.55rem 0.65rem;\n    border-radius: 5px;\n    border: 1px solid var(--m-border, #e5e7eb);\n    background: var(--m-subtle, #f8f9fb);\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n\n    &--nested {\n      background: var(--m-background-card, #fff);\n    }\n  }\n\n  .shift-form-page__break-card-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .shift-form-page__break-index {\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: var(--m-text);\n  }\n\n  .shift-form-page__empty-breaks {\n    text-align: center;\n    padding: 1.75rem 1rem;\n    font-size: 0.8125rem;\n    color: var(--m-text-subtle, #6b7280);\n    border: 1px dashed var(--m-border, #e5e7eb);\n    border-radius: var(--m-border-radius, 6px);\n    line-height: 1.5;\n  }\n\n  .shift-form-page__time-row {\n    display: flex;\n    gap: 0.35rem;\n\n    > div {\n      flex: 1;\n      min-width: 0;\n      max-width: 6.5rem;\n    }\n  }\n\n  .shift-form-page__active-row {\n    padding-top: 0.25rem;\n    border-top: 1px solid var(--m-border, #e5e7eb);\n    margin-top: auto;\n  }\n}\n\n.shift-form-loading .spin {\n  animation: shifts-spin 1s linear infinite;\n}\n\n@keyframes shifts-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.shift-form-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 1.5rem;\n  color: var(--m-text-subtle, #6b7280);\n\n  svg {\n    color: var(--m-primary);\n    margin-bottom: 1rem;\n  }\n\n  p {\n    margin: 0;\n    font-size: 0.9375rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
